<template>
  <div class="wrapper">

    <div class="header_wrapper">

      <v-toolbar
        color="primary"
        dark
      >
        <v-btn
          @click="routerBack"
          icon
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title class="flex-grow-1 text-center ml-0">成長記録</v-toolbar-title>
        <v-btn icon disabled style="visibility: hidden">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-toolbar>

    </div>

    <v-list density="compact">
      <!-- 1. key は template タグに移動し、v-list-item-group は削除 -->
      <template v-for="(c, index) in children" :key="c.childId">
        
        <v-list-item
          @click="to( c.childId, c.lastName + c.firstName )"
        >
          <!-- 2. 左側の画像: prepend スロット + v-avatar を使用 -->
          <template v-slot:prepend>
            <v-avatar class="ml-2">
              <v-img
                :src="c.imageUrl ? c.imageUrl : 'https://via.placeholder.com/240x180?text=Sample+Image+1'"
              />
            </v-avatar>
          </template>

          <!-- 3. 中央のテキスト: v-list-item-content 廃止 → title を直下に配置 -->
          <v-list-item-title v-text="c.lastName + c.firstName"></v-list-item-title>

        </v-list-item>

        <v-divider />
      </template>
    </v-list>

  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';

import { familyModule } from '@/store/entityModules/family';

export default defineComponent({

  computed: {
    children() {
      if (familyModule.family) {
        return familyModule.family.children;
      }
      return [];
    },
  },

  data: () => ({
  }),

  methods: {
    routerBack() {
      this.$router.replace('/setting');
    },
    to(childId: string, childName: string) {
      this.$router.push({ name: 'Growth', query: {
        childId,
        childName,
      } });
    },
  },
});
</script>
<style lang="scss" scoped>
.wrapper {
  padding-top: calc(var(--app-top-offset) + 56px); // ← ヘッダー分
  margin-bottom: calc(env(safe-area-inset-bottom) + 56px);
}

/* ===== ヘッダー ===== */
.header_wrapper {
  height: 56px;
  width: 100%;
  position: fixed;
  top: var(--app-top-offset); // ← 超重要
  left: 0;
  z-index: 100;

  .outline {
    border: 1px solid rgb(var(--v-theme-primary));
  }
}

/* ===== フォーム余白 ===== */
.v-form {
  margin-top: 8px;
}

/* ===== ラベルサイズ ===== */
.label-size > .v-input__control > .v-input__slot > .v-input--selection-controls__input > label {
  font-size: 12px;
}
// リストはヘッダー分だけ下げる
.v-list {
  margin-top: calc(env(safe-area-inset-top));
}
</style>
